var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeaport02 = function SvgSeaport02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "seaport-02_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#seaport-02_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.22 16.113c-.746-.904-1.432-2.348-1.826-3.508-.458 1.136-1.224 2.539-2.018 3.4l1.043-.344a3.9 3.9 0 0 1-2.745 1.98V10.9h2.286V9.555h-2.286v-.782A1.973 1.973 0 0 0 13.97 6.92c0-1.086-.884-1.97-1.97-1.97-1.086 0-1.97.884-1.97 1.97 0 .85.54 1.576 1.296 1.852v.782H9.038v1.348h2.287v6.739A3.905 3.905 0 0 1 8.58 15.66l1.043.345c-.795-.861-1.56-2.265-2.017-3.402-.394 1.16-1.082 2.604-1.827 3.508l1.301-.511A5.25 5.25 0 0 0 12 19.05c2.207 0 4.175-1.4 4.918-3.448l1.3.512h.002ZM12 6.3a.624.624 0 0 1 0 1.245.624.624 0 0 1 0-1.245Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "seaport-02_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgSeaport02 as ReactComponent };